<template>
    <div class="traveldate-content-wrapper">
        <ContentHeadline class="ch-first-question" id="tdo-first-question" v-if="step.firstQuestion">{{step.firstQuestion}}</ContentHeadline>
        <div class="row btn-group-toggle user-choice" data-toggle="buttons" role="radiogroup" aria-labelledby="tdo-first-question">
              <div class="col-md-4 col-12 choice" v-if="offersExists()">
                <input id="anfrage_type0"
                       type="radio"
                       :value="REQUEST_TYPES.offer"
                       v-model="step.anfrage_type"
                       autocomplete="off"
                       class="btn-check"
                       :class="{ 'is-invalid': errors.anfrage_type }"
                       required
                       @change="handleAnfrage(true)"
                >
                <label for="anfrage_type0"
                         class="btn btn-outline-info w-100 mb-1 mb-md-0"
                         :class="{active:step.anfrage_type === REQUEST_TYPES.offer}"
                  >
                    {{ $t('mod.traveldateoffer.requestType.offer') }}
                  </label>
              </div>

              <div class="col-md-4 col-12 choice" v-if="accommodationExists()">
                <input type="radio"
                       :value="REQUEST_TYPES.accommodation"
                       name="anfrage_type"
                       id="anfrage_type1"
                       v-model="step.anfrage_type"
                       autocomplete="off"
                       class="form-control btn-check sr-only visually-hidden-focusable"
                       :class="{ 'is-invalid': errors.anfrage_type }"
                       required
                       @change="handleAnfrage(true)"
                >
                  <label for="anfrage_type1"
                         class="btn btn-outline-info w-100 mb-1 mb-md-0"
                         :class="{active:step.anfrage_type === REQUEST_TYPES.accommodation}">
                    {{ $t('mod.traveldateoffer.requestType.accommodation') }}
                  </label>
              </div>

              <div class="col-md-4 col-12 choice" v-if="showDiverse()">
                <input type="radio"
                       name="anfrage_type"
                       id="anfrage_type3"
                       :value="REQUEST_TYPES.diverse"
                       v-model="step.anfrage_type"
                       autocomplete="off"
                       class="form-control btn-check sr-only visually-hidden-focusable"
                       :class="{ 'is-invalid': errors.anfrage_type }"
                       required
                       @change="handleAnfrage(true)"
                >
                  <label for="anfrage_type3"
                         class="btn btn-outline-info w-100 mb-1 mb-md-0"
                         :class="{active:step.anfrage_type === REQUEST_TYPES.diverse}">
                      {{ getDiverseTitle() }}
                  </label>
              </div>

              <div class="col-md-4 col-12 choice">
                <input type="radio"
                       name="anfrage_type"
                       id="anfrage_type2"
                       :value="REQUEST_TYPES.message"
                       v-model="step.anfrage_type"
                       autocomplete="off"
                       class="form-control btn-check sr-only visually-hidden-focusable"
                       :class="{ 'is-invalid': errors.anfrage_type }"
                       required
                       @change="handleAnfrage(true)"
                >
                  <label for="anfrage_type2"
                         class="btn btn-outline-info w-100 mb-1 mb-md-0"
                         v-if="!onlyMessageExists()"
                         :class="{active:step.anfrage_type === REQUEST_TYPES.message}">
                    {{ $t('mod.traveldateoffer.requestType.message') }}
                  </label>
              </div>

          <div class="col-12 invalid-feedback is-invalid d-block" v-if="showNextDisabledHint && errors.anfrage_type">
            {{ $t('mod.traveldateoffer.errors.requestType') }}
          </div>
        </div>

        <div :class="{active: step.anfrage_type === REQUEST_TYPES.accommodation}"
             class="animate form-element-bg form-element mt-4">
            <div class="col-12">
                <ContentHeadline class="ch-which-date ch-which-date-accommodation">
                  {{ $t('form.hint.travelDate') }}
                </ContentHeadline>
                <DateRangeSelects :step="step" ref="dateRangeSelectAccommodation"
                                  id-prefix="accommodation"
                                  :checkin-label="$t('item.accommodation.checkin')"
                                  :checkout-label="$t('item.accommodation.checkout')"
                />
                <div v-if="errors.nights" class="invalid-feedback is-invalid d-block">
                  {{ this.errors.nights_message }}
                </div>
            </div>
        </div>

        <div v-if="offersExists()" :class="{active: step.anfrage_type === REQUEST_TYPES.offer}"
             class="form-element form-element-bg animate mt-4">
            <ContentHeadline class="col-12 ch-which-offer" :id="createHeadlineId($t('mod.traveldateoffer.offer.title'))">
              {{ $t('mod.traveldateoffer.offer.title') }}
            </ContentHeadline>
            <div class="row">
                <div :class="{ error: errors.offer}" class="col-12 col-md-8 mb-3">
                    <select @change="handleOffer()"
                            v-model="step.selectedOffer"
                            name="angebot"
                            :aria-labelledby="createHeadlineId($t('mod.traveldateoffer.offer.title'))"
                            required
                            class="form-control fw-bold form-select"
                            :class="{ 'is-invalid': errors.offer }"
                    >
                        <option disabled value="">{{ $t('form.hint.selectPrompt', { item: $t('item.offer.title', 1)}) }}</option>
                        <option :value=offer.title v-for="(offer) in step.offers">{{offer.title}}</option>
                    </select>
                </div>
            </div>

            <div class="row" v-for="(offer) in step.offers" v-show="step.selectedOffer === offer.title">
                <div class="col-12 col-lg-6">
                    <img class="img-fluid" :alt="offer.title" :src="offer.img">
                </div>
                <div class="col-12 col-lg-6">
                    <div class="fw-bold">{{offer.priceString}}</div>
                    <ul>
                        <li class="mb-1" v-for="(component) in offer.components">
                            <i :class="`${$store.state.faClass} fa-check fa-fw`"></i>{{component}}
                        </li>
                    </ul>
                    <a target=_blank class="form-link" :href="offer.url">
                      {{ $t('mod.traveldateoffer.offer.readMore') }}
                      <i :class="`${$store.state.faClass} fa-external-link ms-1`"></i>
                    </a>
                    <template v-if="offer.availability && offer.availability.start && offer.availability.end">
                        <div class="fw-bold mt-2">{{ $t('item.offer.period') }}</div>
                        <div :class="{'invalid-feedback': errors.checkin || errors.checkout, 'd-block': errors.checkin || errors.checkout}">
                            <i v-if="errors.checkin || errors.checkout" class="fas fa-exclamation"></i>
                          {{ formatDateForDisplay(offer.availability.start) }} -
                          {{ formatDateForDisplay(offer.availability.end) }}
                        </div>
                    </template>
                </div>
            </div>

            <div class="row mt-3" v-show="step.selectedOffer !== ''">
                <div class="col-12">
                    <ContentHeadline class="ch-which-date ch-which-date-offer">{{ $t('form.hint.travelDate') }}</ContentHeadline>
                    <DateRangeSelects :step="step"
                                      id-prefix="offer"
                                      :checkin-label="$t('item.accommodation.checkin')"
                                      :checkout-label="$t('item.accommodation.checkout')"
                                      :min-date="currentOfferMinDate" :max-date="currentOfferMaxDate"
                                      :nights="currentOfferNights"
                                      ref="dateRangeSelectOffer"
                    />
                    <div v-if="errors.date" class="invalid-feedback is-invalid d-block">
                      {{ $t('mod.traveldateoffer.errors.period') }}
                    </div>
                    <div v-if="errors.nights" class="invalid-feedback is-invalid d-block">
                      {{ this.errors.nights_message }}
                    </div>
                </div>
            </div>
        </div>
        <div :class="{active: step.anfrage_type === REQUEST_TYPES.message}" class="animate mt-4 pt-0">
            <label for="tdo-message" class="sr-only visually-hidden-focusable">{{ $t('mod.traveldateoffer.message.title') }}</label>
            <textarea v-model="step.message"
                      id="tdo-message"
                      required
                      rows="10"
                      class="form-control h-auto"
                      :class="{ 'is-invalid': errors.message }"
                      :placeholder="$t('mod.traveldateoffer.message.title')"
                      @change="handleMessage()"
            ></textarea>
        </div>

        <div class="form-element-bg form-element mt-4" v-if="nextStepTdoDescription" v-html="nextStepTdoDescription" />

        <div class="form-element row justify-content-end mt-5 mb-4 ">
            <div class="col-12 col-md-4">
                <div class="alert alert-warning next-disabled-js" role="alert" v-show="showNextDisabledHint">
                  {{ $t('form.hint.nextDisabled') }}
                </div>
                <button type="button" @click="clickNext" class="btn btn-dark btn-block next">
                    {{ $t('form.action.next') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import dayjs from 'dayjs'
    import mixinCreateId from "../mixins/createId";
    import DateRangeSelects from './partials/DateRangeSelects.vue';
    import ContentHeadline from "./partials/ContentHeadline.vue";
    import { setLocale } from "../../forms6/i18n";

    export default {
        mixins: [mixinCreateId],
        props: ['step'],
        data() {
            return {
                showNextDisabledHint: false,
                errors: {
                    anfrage_type: false,
                    date: false,
                    offer: false,
                    nights: false,
                    message: false
                },
            };
        },
        created() {
          if (!this.step.checkin && !this.step.checkout) {
            this.step.tryToPresetDates(this.$store);
          }
          this.step.wasValidated = false;

          // trigger display of "tdoDescription" if anfrage_typ is initialized from query parameter
          this.handleAnfrage()
        },
        methods: {
          setLocale(locale) {
            setLocale(locale)
          },
          formatDateForDisplay(date) {
            return dayjs(date).format(this.$t('date.formatDate'))
          },
            handleAnfrage(userClick = false) {
                if (userClick) {
                  this.step.reset();
                  this.resetDatePicker()
                  if (this.step._presetDates.checkin && this.step._presetDates.checkin) {
                    this.step.tryToPresetDates(this.$store);
                    this.$refs.dateRangeSelectOffer?.reload()
                    this.$refs.dateRangeSelectAccommodation?.reload()
                  }
                  this.updateDateRangeSelectClasses(true)
                }

                //reset offer if previously selected
                if(userClick && this.step.selectedOffer) {
                    this.step.selectedOffer = ''
                    // this.handleDatePicker() // disabled because it triggers "invalid" classes on checkin/checkout
                }
                this.showNextDisabledHint = false;
                this.errors.anfrage_type = !this.step.anfrage_type;

                if (this.step.anfrage_type === this.REQUEST_TYPES.message) {
                    if (this.moduleExists('accommodation')) {
                        this.$store.state.steps['accommodation'].disable();
                    }
                    if (this.moduleExists('diverse')) {
                        this.$store.state.steps['diverse'].disable()
                    }
                } else {
                    this.$store.state.steps['accommodation'].isActive = true;
                    if (this.moduleExists('diverse')) {
                        this.$store.state.steps['diverse'].isActive = true;
                    }
                }

                if (this.step.anfrage_type === this.REQUEST_TYPES.accommodation) {
                    if (this.moduleExists('diverse') && !this.$store.state.steps['diverse'].keepActiveAfterTraveldateOffer) {
                        this.$store.state.steps['diverse'].disable()
                    }
                }
                console.log("this.step.anfrage_type", this.step.anfrage_type, this.REQUEST_TYPES.diverse)
                if (this.step.anfrage_type === this.REQUEST_TYPES.diverse) {
                    if (this.moduleExists('accommodation')) {
                        this.$store.state.steps['accommodation'].disable()
                    }
                }

              if (this.step.anfrage_type === this.REQUEST_TYPES.offer) {
                if (this.moduleExists('diverse')) {
                  this.$store.state.steps['diverse'].disable()
                }
              }
                return !this.errors.anfrage_type;
            },
            handleOffer() {
                this.showNextDisabledHint = false;
                const offerRequired = this.step.anfrage_type === this.REQUEST_TYPES.offer;
                const summaryLabel = 'Angebot';
                this.step.deleteFromSummary(summaryLabel);
                // console.log("Summary-handleOffer", this.step.debugSummaryString())

                this.errors.offer = false;

                if (offerRequired) {
                    const offerSelected = this.step.selectedOffer !== '';
                    if (offerSelected) {
                        this.step.addToSummary({label: summaryLabel, text: this.step.selectedOffer});
                    } else {
                        this.errors.offer = true;
                    }
                }
                this.$store.commit('updateUserInput', {
                    name: 'angebot',
                    module: this.step.type,
                    input: this.errors.offer ? null : this.step.selectedOffer
                });

                return !this.errors.offer;
            },

            resetDatePicker() {
              this.$store.commit('updateUserInput', {
                name: this.step.fieldName('checkin'),
                module: this.step.type,
                input: null
              });
              this.$store.commit('updateUserInput', {
                name: this.step.fieldName('checkout'),
                module: this.step.type,
                input: null
              });
              this.$store.commit('setTravelDate', null);
              this.step.updatePicker(null, null, null, true);
              this.$refs.dateRangeSelectOffer?.reload()
              this.$refs.dateRangeSelectAccommodation?.reload()
            },

          validateDates() {
            this.errors.checkin = false
            this.errors.checkout = false
            this.errors.nights = false

            const checkRequestTypes = [this.REQUEST_TYPES.offer, this.REQUEST_TYPES.accommodation]
            if (!checkRequestTypes.includes(this.step.anfrage_type)) {
              // not our business -> everything's fine
              return true
            }

            const conditions = {
              nights: null,
              minNights: this.step.minNights || 1,
              maxNights: null,
              minDate: null,
              maxDate: null,
            }
            if(this.step.selectedOffer) {
              const currentOffer = this.step.offers.find((offer) => offer.title === this.step.selectedOffer)
              if (currentOffer.availability?.start && currentOffer.availability?.end) {
                conditions.minDate = dayjs(currentOffer.availability.start)
                conditions.maxDate = dayjs(currentOffer.availability.end)
              }
              if (currentOffer.min_nights) {
                conditions.minNights = currentOffer.min_nights
              }
              if (currentOffer.max_nights) {
                conditions.maxNights = currentOffer.max_nights
              }
              if (currentOffer.nights) {
                conditions.nights = currentOffer.nights
              }
            }

            const checkinValuePresent = this.step.fieldName('checkin') in this.$store.state.steps[this.step.type].userInputs
            if (!checkinValuePresent) {
              this.errors.checkin = true
              return false
            }

            const checkoutValuePresent = this.step.fieldName('checkout') in this.$store.state.steps[this.step.type].userInputs
            if (!checkoutValuePresent) {
              this.errors.checkout = true
              return false
            }

            // durationValue seem to be nights
            if (conditions.nights) {
              if (this.step.durationValue !== conditions.nights) {
                this.errors.nights = true
                // this.errors.nights_message = `Bitte genau ${conditions.nights + 1} Tage (${conditions.nights} Übernachtungen) auswählen.`
                this.errors.nights_message = this.$t("mod.traveldateoffer.errors.nights", {
                  days: conditions.minNights + 1,
                  nights: conditions.minNights
                })
              }
            } else {
              if (conditions.minNights && (this.step.durationValue < conditions.minNights)) {
                this.errors.nights = true
                // this.errors.nights_message = `Bitte mindestens ${conditions.minNights + 1} Tage auswählen (${conditions.minNights} Mindestübernachtungen).`
                this.errors.nights_message = this.$t("mod.traveldateoffer.errors.minNights", {
                  days: conditions.minNights + 1,
                  nights: conditions.minNights
                })
              }
              if (conditions.maxNights && (this.step.durationValue > conditions.maxNights)) {
                this.errors.nights = true
                // this.errors.nights_message = `Bitte höchstens ${conditions.maxNights + 1} Tage auswählen (maximal ${conditions.maxNights} übernachtungen).`
                this.errors.nights_message = this.$t("mod.traveldateoffer.errors.maxNights", {
                  days: conditions.maxNights + 1,
                  nights: conditions.maxNights
                })
              }
            }

            const checkin = dayjs(this.$store.state.steps[this.step.type].checkin)
            const checkout = dayjs(this.$store.state.steps[this.step.type].checkout)
            if (conditions.minDate) {
              if (checkin.isBefore(conditions.minDate)) {
                this.errors.checkin = true
              }
              if (checkout.isBefore(conditions.minDate)) {
                this.errors.checkout = true
              }
            }
            if (conditions.maxDate) {
              if (checkin.isAfter(conditions.maxDate)) {
                this.errors.checkin = true
              }
              if (checkout.isAfter(conditions.maxDate)) {
                this.errors.checkout = true
              }
            }
          },

          updateDateRangeSelectClasses(reset = false) {
            document.querySelectorAll('.traveldate-content-wrapper .date-range-selects .checkin.form-control').forEach((e) => {
              // attention: do not use 'undefined'
              e.classList.toggle('is-invalid', reset ? false : !!this.errors.checkin);
              e.classList.toggle('is-valid', reset ? false : !this.errors.checkin);
            });
            document.querySelectorAll('.traveldate-content-wrapper .date-range-selects .checkout.form-control').forEach((e) => {
              e.classList.toggle('is-invalid', reset ? false : !!this.errors.checkout);
              e.classList.toggle('is-valid', reset ? false : !this.errors.checkout);
            });
          },

            handleDatePicker(userClick) {
              if (userClick) {
                // user has selected his own dates => clear presetDates
                this.step._presetDates = {}
              }

              this.showNextDisabledHint = false;

              this.validateDates()
              this.updateDateRangeSelectClasses()

              const checkin = dayjs(this.$store.state.steps[this.step.type].checkin)
              const checkout = dayjs(this.$store.state.steps[this.step.type].checkout)
                if (checkin.isValid()) {
                    const summaryLabel = this.$t('form.hint.travelDate');
                    this.step.deleteFromSummary(summaryLabel);
                    const startMoment = dayjs(checkin);
                    const endMoment = dayjs(checkout);
                    const text = this.formatDateForDisplay(startMoment) + ' - ' + this.formatDateForDisplay(endMoment) + this.step.duration.replace(' = ', ', ');
                    this.$store.commit('updateUserInput', {
                        name: 'meine_anfrage',
                        module: this.step.type,
                        input: 'Meine Anfrage: '
                    });
                    this.$store.commit('setTravelDate', {step: this.step.index, text: text});
                    this.step.addToSummary({label: summaryLabel, text: text});
                }
                return !this.errors.checkin && !this.errors.checkout && !this.errors.nights;
            },

            handleMessage() {
                this.showNextDisabledHint = false;
                this.errors.message = false;
                let newValue = this.step.message;
                const summaryLabel = this.$t('mod.traveldateoffer.message.summaryTitle')
                this.step.deleteFromSummary(summaryLabel)

                if (this.step.anfrage_type === this.REQUEST_TYPES.message) {
                    if (newValue === '') {
                        this.errors.message = true;
                    }
                    this.step.addToSummary({label: summaryLabel, text: this.step.message});
                } else {
                    newValue = null;
                }

                this.$store.commit('updateUserInput', {
                    name: 'sonstige_wuensche',
                    module: this.step.type,
                    input: newValue
                });

                return !this.errors.message;
            },

            validate() {
                this.step.wasValidated = true;
                const validations = [
                    this.handleAnfrage(),
                    this.handleOffer(),
                    this.handleDatePicker(),
                    this.handleMessage(),
                ];
                // console.log(JSON.stringify({
                //   handleAnfrage: validations[0] ? 'ok' : 'FEHLER',
                //   handleOffer: validations[1] ? 'ok' : 'FEHLER',
                //   handleDatePicker: validations[2] ? 'ok' : 'FEHLER',
                //   handleMessage: validations[3] ? 'ok' : 'FEHLER',
                // }));
                // all true?
                return validations.every(v => v);
            },
            clickNext(e) {
                if (this.validate()) {
                    this.$store.commit('setNextStep');
                } else {
                    this.showNextDisabledHint = true;
                }
            },
            clickPrev(e) {
                this.$store.commit('setLastStep');
            },
            offersExists() {
                return typeof this.step.offers !== 'undefined';
            },
            showDiverse: function() {
                const diverseModule = this.$store.state.steps['diverse'];
                if(typeof diverseModule !== 'undefined') {
                    if(diverseModule.showInTraveldateOffer) {
                        return true;
                    }
                }
                return false;
            },
            getDiverseTitle: function() {
                const diverseModule = this.$store.state.steps['diverse'];
                if(typeof diverseModule !== 'undefined') {
                    return this.$store.state.steps['diverse'].title;
                }
                return '';
            },
            accommodationExists() {
                return typeof this.$store.state.steps['accommodation'] !== 'undefined';
            },
            onlyMessageExists() {
                if (!this.offersExists() && !this.accommodationExists()) {
                    this.step.anfrage_type = 'Mitteilung senden';
                    return true;
                }
                return false;

            }
        },
        computed: {
          REQUEST_TYPES() {
            return this.step.getRequestTypes
          },
          currentOffer() {
            if(this.step.selectedOffer) {
              return this.step.offers.find((offer) => offer.title === this.step.selectedOffer)
            }
            return null
          },
          currentOfferMinDate() {
            return this.currentOffer?.availability?.start
          },
          currentOfferMaxDate() {
            return this.currentOffer?.availability?.end
          },
          currentOfferNights() {
            return this.currentOffer?.nights
          },
          nextStepTdoDescription() {
            if (!this.$store.getters.nextStep) {
              return
            }

            let text = this.$store.getters.nextStep.tdoDescription;
            if (!text) {
              return
            }

            const num = this.$store.state.contact.telephone
            text = text.replaceAll('{{telephone}}', num)
            text = text.replaceAll('{{telephone_link}}', `<a href="tel:${num}">${num}</a>`)

            return text
          }
        },
        components: {
          ContentHeadline,
          DateRangeSelects,
        },
    }
</script>